import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-engine-plots',
  templateUrl: './engine-plots.component.html',
  styleUrls: ['./engine-plots.component.scss']
})
export class EnginePlotsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
